import { gql } from '@apollo/client';

export const UPLOADFILE = gql`
  mutation UploadFile($input: FileUploadInput!) {
    uploadFile(input: $input)
  }
`;
